import authRules from '../authRules';

const editMode = (user) => {
  const { scheduleData } = user.securityLevels;
  if (scheduleData >= authRules.editMode.scheduleData) {
      return true;
  } else {
      return false;
    }
  }


export default editMode;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/editMode.js